export const PERMISSION_CODES = {
  campanas: {
    create: 'campanas.create',
    view: 'campanas.view',
    edit: 'campanas.edit',
    delete: 'campanas.delete',
  },
  landings: {
    create: 'landings.create',
    view: 'landings.view',
    edit: 'landings.edit',
    uploadimage: 'landings.uploadimage',
  },
  predictores: {
    create: 'predictores.create',
    view: 'predictores.view',
    edit: 'predictores.edit',
    publish: 'predictores.publish',
    pause: 'predictores.pause',
    resume: 'predictores.resume',
    uploadicon: 'predictores.uploadicon',
    resolve: 'predictores.resolve',
    reresolve: 'predictores.reresolve',
  },
  registros: {
    view: 'registros.view',
    marksynced: 'registros.marksynced',
    retrysync: 'registros.retrysync',
  },
  pronosticos: {
    view: 'pronosticos.view',
  },
  catalogos: {
    view: 'catalogos.view',
    create: 'catalogos.create',
    edit: 'catalogos.edit',
    toggle: 'catalogos.toggle',
    togglestatus: 'catalogos.togglestatus',
    uploadimage: 'catalogos.uploadimage',
    adjuststock: 'catalogos.adjuststock',
  },
  metricas: {
    view: 'metricas.view',
  },
  widget: {
    view: 'widget.view',
    create: 'widget.create',
    activate: 'widget.activate',
    deactivate: 'widget.deactivate',
    reorder: 'widget.reorder',
    edit: 'widget.edit',
  },
  usuarios: {
    create: 'usuarios.create',
    view: 'usuarios.view',
    edit: 'usuarios.edit',
    changepassword: 'usuarios.changepassword',
    deactivate: 'usuarios.deactivate',
  },
  bonos: {
    view: 'bonos.view',
    create: 'bonos.create',
    edit: 'bonos.edit',
    deactivate: 'bonos.deactivate',
    manageAgents: 'bonos.manage-agents',
  },
  premios: {
    view: 'premios.view',
    markcredited: 'premios.markcredited',
    markfailed: 'premios.markfailed',
    retry: 'premios.retry',
  },
  canjes: {
    view: 'canjes.view',
    credit: 'canjes.credit',
    retry: 'canjes.retry',
  },
  tags: {
    create: 'tags.create',
    view: 'tags.view',
    edit: 'tags.edit',
  },
  jugadores: {
    view: 'jugadores.view',
    grantpoints: 'jugadores.grantpoints',
  },
  notificaciones: {
    view: 'notificaciones.view',
    markread: 'notificaciones.markread',
  },
  sistema: {
    view: 'sistema.view',
    edit: 'sistema.edit',
  },
  auditoria: {
    view: 'auditoria.view',
  },
  roles: {
    view: 'roles.view',
    create: 'roles.create',
    edit: 'roles.edit',
    activate: 'roles.activate',
    deactivate: 'roles.deactivate',
    permissions: 'roles.permissions',
  },
} as const;

type PermissionModuleKey = keyof typeof PERMISSION_CODES;

export type PermissionCode = {
  [
    M in PermissionModuleKey
  ]: (typeof PERMISSION_CODES)[M][keyof (typeof PERMISSION_CODES)[M]];
}[PermissionModuleKey];

export const requires = (
  permission: PermissionCode,
): { permission: PermissionCode } => ({
  permission,
});

export const requiresAny = (
  ...permissions: PermissionCode[]
): { permissions: PermissionCode[] } => ({ permissions });
